
import { Link } from 'react-router-dom';

export default function Footer() {
  const productCategories = [
    { name: 'Weight Management', path: '/category/weight-management' },
    { name: 'Recovery & Repair', path: '/category/recovery-repair' },
    { name: 'Longevity & Cellular', path: '/category/longevity-cellular' },
    { name: 'Growth Hormone', path: '/category/growth-hormone' },
    { name: 'Cognitive & Neuro', path: '/category/cognitive-neuro' },
    { name: 'Amino Acids & Blends', path: '/category/amino-blends' },
  ];

  const companyLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'How to Order', path: '/how-to-order' },
    { name: 'Quality & Testing', path: '/quality' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-50 to-white text-navy-900 relative overflow-hidden border-t border-gray-200">
      {/* Background Watermark */}
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.015] pointer-events-none">
        <span className="text-9xl font-bold tracking-wider">DNBIO</span>
      </div>

      {/* Research Use Only Disclaimer Banner */}
      <div className="relative bg-red-50 border-b-2 border-red-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-center space-x-3">
            <i className="ri-alert-line text-red-600 text-xl flex-shrink-0"></i>
            <p className="text-sm font-semibold text-red-900 text-center">
              For Research Use Only. Not for human consumption, medical use, or household application.
            </p>
          </div>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-5">
              <img
                src="https://static.readdy.ai/image/f774deb3335ef344be2f4793f6ebd557/d3524caf242f33efd937ef8bb569492a.png"
                alt="DN Bio Research Logo"
                className="h-11 w-auto"
              />
            </div>
            <p className="text-navy-600 text-sm mb-6 leading-relaxed max-w-xs">
              B2B research supplier providing high-purity peptides and compounds for laboratory research and scientific applications.
            </p>
            <div className="space-y-3 mb-6">
              <p className="text-navy-600 text-sm flex items-start">
                <i className="ri-map-pin-line mr-2 text-primary-600 mt-0.5 flex-shrink-0"></i>
                <span>1302 Waugh Dr. #413<br />Houston, TX 77019, USA</span>
              </p>
              <a
                href="https://wa.me/639178850200"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-green-600 hover:text-green-700 text-sm cursor-pointer font-medium transition-colors"
              >
                <i className="ri-whatsapp-line mr-2 text-lg"></i>
                WhatsApp
              </a>
            </div>
            <Link
              to="/shop"
              className="btn btn-secondary btn-sm"
            >
              Browse Catalog
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>

          {/* Products Column */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider mb-5 text-navy-900">Research Products</h3>
            <ul className="space-y-3">
              {productCategories.map((category) => (
                <li key={category.path}>
                  <Link
                    to={category.path}
                    className="text-navy-600 text-sm hover:text-primary-600 transition-colors cursor-pointer inline-block"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider mb-5 text-navy-900">Company</h3>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-navy-600 text-sm hover:text-primary-600 transition-colors cursor-pointer inline-block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Payment & Contact Column */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider mb-5 text-navy-900">Payment Methods</h3>
            <p className="text-xs text-navy-500 mb-3 italic">Available after quote approval</p>
            <div className="grid grid-cols-2 gap-3 mb-6">
              <div className="flex items-center space-x-2 text-navy-600 text-sm">
                <i className="ri-bit-coin-line text-primary-600 text-base"></i>
                <span>BTC</span>
              </div>
              <div className="flex items-center space-x-2 text-navy-600 text-sm">
                <i className="ri-currency-line text-primary-600 text-base"></i>
                <span>ETH</span>
              </div>
              <div className="flex items-center space-x-2 text-navy-600 text-sm">
                <i className="ri-coin-line text-primary-600 text-base"></i>
                <span>USDT</span>
              </div>
              <div className="flex items-center space-x-2 text-navy-600 text-sm">
                <i className="ri-bank-card-line text-primary-600 text-base"></i>
                <span>Card</span>
              </div>
              <div className="flex items-center space-x-2 text-navy-600 text-sm">
                <i className="ri-paypal-line text-primary-600 text-base"></i>
                <span>PayPal</span>
              </div>
            </div>
            <p className="text-xs text-navy-500 mb-4 leading-relaxed">
              Payment processed only after manual quote approval and order confirmation.
            </p>
            <a
              href="https://wa.me/639178850200"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-5 py-2.5 bg-green-600 text-white text-sm font-semibold rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Request Quote
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-gray-200">
          {/* Compliance Notice */}
          <div className="mb-6 text-center">
            <p className="text-xs text-navy-500 leading-relaxed max-w-4xl mx-auto">
              <strong className="text-navy-700">Research Compliance Notice:</strong> All products are intended solely for laboratory research by qualified researchers and institutions. Not for human consumption, medical use, veterinary use, or household application. No medical claims are made or implied. Customers must comply with all applicable regulations.
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-navy-500 text-sm">
              © 2025 DNBio. All rights reserved. B2B Research Supplier.
            </p>
            <div className="flex items-center space-x-6">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-navy-500 text-sm hover:text-primary-600 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
              <a href="#" className="text-navy-400 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-navy-400 hover:text-primary-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
